<script>
import genericService from '../../services/genericService';
import CommonService from '../../services/common';

import Panel from 'primevue/panel';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';

export default{
  components: {
    AutoComplete,
    Panel,
    Checkbox
},
  props: [],
  data(){
    return {
      selectedItem: null,
      filteredData: [],
      data: [],
      results: [],
      isStrict: false
    }
  },
  mounted(){
    this.generateList(this.securityMenu);
    this.selectedItem = this.$route.query.q;
    this.isStrict = this.$route.query.strict === 'true';
    this.getSearchResults();
  },
  computed: {
    securityMenu(){
      return this.$store.state.security.menu;
    },
  },
  watch: {
    securityMenu(newValue){
      this.generateList(newValue)
    },
    selectedItem(newValue){
      if(newValue && newValue.to){
        this.$router.push(newValue.to);
      }
    }
  },
  methods: {
    goBack(){
        this.$router.back();
    },
    search() {
      this.getSearchResults();
    },
    searchItem(event){
      if (!event.query.trim().length) {
        this.filteredData = [...this.data];
      }else {
        this.filteredData = this.data.filter((item) => {
          return item.label.toLowerCase().includes(event.query.toLowerCase());
        });

        CommonService.elasticSearch(event.query.toLowerCase(), resp => {
          console.log(resp)
        })

      }
    },
    generateList(){
      this.data = [];

      for(let i=0; i<this.securityMenu.length; i++){
        let item = this.securityMenu[i];
        if(item.to){
          this.data.push({
            label: item.label,
            to: item.to
          });
        }else{
          let children = item.items;
          for(let k=0; k<children.length; k++){
            let child = children[k];
            if(child.to){
              this.data.push({
                label: child.label,
                to: child.to
              });

              this.data.push({
                label: this.$t('create') + ' ' + child.label,
                to: child.to + '/0'
              })
            }
          }
        }
      }
    },
    async getSearchResults(){
      if (this.selectedItem) {
        const query = this.isStrict ? this.selectedItem : (".*" + this.selectedItem + ".*");
        await genericService.get('search-engine/search?index='+query).then(({data}) => {
            if(data.hits.total.value) {
                this.results = data.hits.hits;
            } else {
              this.results = [];
            }
        })
      }
    },
    goToItem ({recordType, id}) {

      // last-fiscal-notification?idScheduledOperation=165

      switch(recordType){
        case 'Fiscal Notification':
          this.$router.push(`/last-fiscal-notification?idScheduledOperation=${id}`);
          break;
        case 'Vessel Protocol':
          this.$router.push(`/vessel-protocol?id=${id}`);
          break;
        case 'Movement Instruction':
          this.$router.push(`/${recordType.replace(/\s+/g, '-').toLowerCase()}/${id}`);
          break;
      }

        
    }
  }
}

</script>

<template>
  <main>
    <Panel style="height: 75vh;">
        <div class="grid">
          <div class="col-8 field center">
            <div class="p-inputgroup">
              <AutoComplete class=" w-full-autocomplete" v-model="selectedItem" :suggestions="filteredData" @complete="searchItem($event)" field="label" @keyup.enter="search"/>
              <span class="p-inputgroup-addon hoverable" @click="search" >
                <i class="pi pi-search"></i>
              </span>
              <div class="strict-box">
                <Checkbox
                v-model="isStrict" :binary="true" name="strict" class="strict"/>
                <label for="strict">{{$t('search.strict')}}</label>  
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
            <div v-for="item in results" :key="item" class="col-12 md:col-6 lg:col-3">
                <div class="card text-center result" @click="goToItem(item._source)" v-tooltip="item._source.recordType">
                  <i class="pi pi-file file"></i>
                    <h4 class="result-title">{{item._source.recordType}}</h4>
                    <span>{{item._source.index}}</span>
                </div>
            </div>
        </div>
      </Panel>
  </main>
</template>

<style scoped>

.result {
  height: 200px;
  overflow-y: auto;
}
.result-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.strict-box {
  display: flex;
  align-items: center;
}

.strict {
  margin: 0 5px;
}

.file {
  font-size: 30px;
  color: darkblue;
}

.hoverable:hover {
  cursor: pointer;
  transition: 0.3s;
  background-color:darkgray;
  color: whitesmoke;
}

</style>